export default __webpack_public_path__ + "static/media/hn-passport.e05007f4.jpg";